// eslint-disable-next-line @typescript-eslint/no-require-imports
import * as DOMPurifyModule from 'dompurify';

// Handle ESM/CJS interop — DOMPurify may export as default or as module
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DOMPurify = (('default' in DOMPurifyModule ? (DOMPurifyModule as any).default : DOMPurifyModule) as any);

// Safe-link hook: force every <a> to open in a new tab with a rel that blocks
// `window.opener` access, so a bot/agent-authored link can never navigate (or
// reach back into) this window. The guard hangs a marker on the DOMPurify
// INSTANCE itself (not a module-local flag) — a module-local `let` only
// protects against repeated imports of THIS module; ts-jest module resets and
// any other module holding its own reference to the same DOMPurify instance
// would still stack a duplicate hook. Marker-on-instance is genuinely
// idempotent across all of that.
if (typeof DOMPurify.addHook === 'function' && !DOMPurify.__cssSafeLinkHook) {
  DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
  DOMPurify.__cssSafeLinkHook = true;
}

/**
 * Sanitize untrusted HTML content using DOMPurify.
 * Removes all potentially dangerous tags and attributes to prevent XSS.
 * Used on ALL customer message content before rendering.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'p', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'hr', 'blockquote', 'code', 'pre'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false,
  }) as string;
}

/**
 * Strip ALL HTML tags and return plain text only.
 * Used for previews and notifications where no HTML is desired.
 */
export function stripHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  }) as string;
}
